const fromNearestStoresQueryToNearestStores = (nearestStoresQueryData) => {
  if (!nearestStoresQueryData) {
    return null;
  }
  try {
    return nearestStoresQueryData.map((entry) => {
      const {
        globalStoreId,
        slug,
        town,
        shortName,
        storeDetailImage,
        distance,
        breadcrumbName,
        breadcrumbSlug
      } = entry;
      const isDistanceInMeters = (value) => typeof value === "number";
      return {
        globalStoreId,
        town,
        shortName,
        distance: isDistanceInMeters(distance) ? distance : void 0,
        slug: slug ?? void 0,
        detailImage: storeDetailImage ?? void 0,
        groupName: breadcrumbName ?? void 0,
        groupPath: breadcrumbSlug ?? void 0
      };
    });
  } catch (e) {
    console.error(
      "Store search query data adapter failed to parse input data correctly.",
      e,
      nearestStoresQueryData
    );
    return null;
  }
};
export {
  fromNearestStoresQueryToNearestStores as default,
  fromNearestStoresQueryToNearestStores
};
//# sourceMappingURL=fromNearestStoresQueryToNearestStores.js.map
